var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatechumene(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.375 9.375C19.375 11.7912 17.4162 13.75 15 13.75C12.5838 13.75 10.625 11.7912 10.625 9.375C10.625 6.95875 12.5838 5 15 5C17.4162 5 19.375 6.95875 19.375 9.375Z",
    fill: "#A70606"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24.375 9.375C24.375 11.1009 22.9759 12.5 21.25 12.5C19.5241 12.5 18.125 11.1009 18.125 9.375C18.125 7.64911 19.5241 6.25 21.25 6.25C22.9759 6.25 24.375 7.64911 24.375 9.375Z",
    fill: "#A70606"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.625 9.375C5.625 11.1009 7.02411 12.5 8.75 12.5C10.4759 12.5 11.875 11.1009 11.875 9.375C11.875 7.64911 10.4759 6.25 8.75 6.25C7.02411 6.25 5.625 7.64911 5.625 9.375Z",
    fill: "#A70606"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 20.625C22.5 23.0412 19.1421 25 15 25C10.8579 25 7.5 23.0412 7.5 20.625C7.5 18.2088 10.8579 16.25 15 16.25C19.1421 16.25 22.5 18.2088 22.5 20.625Z",
    fill: "#A70606"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M27.5 20.625C27.5 22.3509 25.2614 23.75 22.5 23.75C19.7386 23.75 17.5 22.3509 17.5 20.625C17.5 18.8991 19.7386 17.5 22.5 17.5C25.2614 17.5 27.5 18.8991 27.5 20.625Z",
    fill: "#A70606"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.5 20.625C2.5 22.3509 4.73857 23.75 7.5 23.75C10.2614 23.75 12.5 22.3509 12.5 20.625C12.5 18.8991 10.2614 17.5 7.5 17.5C4.73857 17.5 2.5 18.8991 2.5 20.625Z",
    fill: "#A70606"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatechumene);
export default __webpack_public_path__ + "static/media/catechumene.8cb647937b8800ff6306e8aeff510398.svg";
export { ForwardRef as ReactComponent };